export const media = (width) => (
  `@media only screen and (min-width: ${width}px)`
);
